export default {
  token: '',
  activeUser: {},
  prevAuthPage: undefined,
  user:[],
  ekioskUser:[],
  userID: '',
  loginOtp:[]
}
